module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 36.37\"><title>quotes</title><path d=\"M12,7.18a12,12,0,0,0,0,24h.32c2.53-.15-6.07,12.52-5.84,12.34C21.43,37.7,24,23,24,19.19A12,12,0,0,0,12,7.18Z\" transform=\"translate(0 -7.18)\"></path><path d=\"M38,7.18a12,12,0,1,0,0,24h.32c2.53-.15-6.07,12.52-5.84,12.34C47.4,37.7,50,23,50,19.19A12,12,0,0,0,38,7.18Z\" transform=\"translate(0 -7.18)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Quotes.svg
// module id = 521
// module chunks = 1